// extracted by mini-css-extract-plugin
module.exports = {"Privacy":"PrivacyModal_Privacy__33b2R","Sub":"PrivacyModal_Sub__1Blkm","FixedButtonsWrapper":"PrivacyModal_FixedButtonsWrapper__1UHF-"};